// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[contenteditable=true][data-v-639e0e66],input[data-v-639e0e66]:focus,textarea[data-v-639e0e66]:focus{outline:none}.formCardTextid[data-v-639e0e66]:empty:before{content:attr(placeholder);color:#afafaf}", ""]);
// Exports
module.exports = exports;
